import React, { useEffect } from "react";
import { PanelTitle } from "../framework/panelTitle";
import { Translations } from "ui/Scripts/source/models/translations";
import { IFrontPageCalendarTaskState } from "source/models/store/storeTypes";
import { CalendarTaskListLine } from "../calendarTask/calendarTaskListLine";
import { customHistory } from "../../framework/customHistory";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { Base } from "ui/Scripts/source/framework/base";
import { FrontPageInfoMessage } from "./frontPageInfoMessage";

interface IFrontPageCalendarProps {
    state: IFrontPageCalendarTaskState;
    loadFrontPageCalendarTask: () => void;
    setLastOpenedCalendarTaskId: (id: string) => void;
    setReturnUrl: (url: string) => void;
}

export const FrontPageCalendar = (props: IFrontPageCalendarProps) => {
    const [hasBeenInitialized, setHasBeenInitialized] = React.useState(false);

    useEffect(() => {
        props.loadFrontPageCalendarTask();
        setHasBeenInitialized(true);
    }, []);

    const editCalendarTask = (id: string) => {
        props.setLastOpenedCalendarTaskId(id !== Base.emptyGuid ? id : "");
        props.setReturnUrl("/front");
        customHistory.push("/calendarTask/" + id);
    };

    const handleCalendarTaskLineClick = (id: string) => {
        editCalendarTask(id);
    };

    const handleAddCalendarTask = () => {
        editCalendarTask(Base.emptyGuid);
    };

    const calendarTasks = props.state?.calendarTasks ?? [];
    
    return (
        <div className="panelContainer">
            <div className="panel calendarPanel">
                <div className="commandRow">
                    <PanelTitle
                        classes="listTitle link"
                        title={Translations.Calendar}
                        onClick={() => customHistory.push("/calendartask")}
                    />
                    <div className="buttonContainer flexRight">
                        <ToolButton
                            classes="add white round mono"
                            stopPropagation={true}
                            onClick={handleAddCalendarTask}
                        />
                    </div>
                </div>
                <div className="panelContent listContainer calendaTaskListContainer">
                    <div className="lineContainer mainLineContainer calendarTaskList">
                        {hasBeenInitialized && !props.state?.isLoading && calendarTasks.length < 1 &&
                            <FrontPageInfoMessage
                                message={Translations.NoCalendarTasksToShow}
                            />
                        }
                        {calendarTasks.map((calendarTask) => (
                            <CalendarTaskListLine
                                item={calendarTask}
                                first={false}
                                isLastOpenedEvent={false}
                                key={calendarTask.id}
                                selected={false}
                                onClick={handleCalendarTaskLineClick}
                                onLongPress={null}
                                onRefreshList={null}
                                onMoveToNextWeek={null}
                                onMoveToPreviousWeek={null}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
